import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { useInstance } from 'intact-vue-next';
import { watchState } from '../../hooks/useState';
import { error } from 'intact-shared';
export function usePoints(showValue, getStep) {
  var instance = useInstance();
  var points = [];
  instance.on('$receive:points', function (v) {
    if (v === true) {
      makeStepPoints();
    } else if (Array.isArray(v)) {
      addStyle(v);
    } else {
      points = [];
    }
  });
  watchState(showValue, addActive);
  function makeStepPoints() {
    var _instance$get = instance.get(),
      max = _instance$get.max,
      min = _instance$get.min,
      step = _instance$get.step;
    if (!step) {
      if (process.env.NODE_ENV !== 'production') {
        error('[Slider]: Step cannot be 0 if you want to show step points.');
      }
      return;
    }
    var results = [];
    var i = min;
    while (true) {
      var _getStep = getStep(i, 'increase'),
        _step = _getStep[0];
      i = i + _step;
      if (Number(i.toFixed(10)) >= max) {
        break;
      }
      results.push(i);
    }
    addStyle(results);
  }
  function addStyle(values) {
    var _instance$get2 = instance.get(),
      min = _instance$get2.min,
      max = _instance$get2.max;
    var total = max - min;
    points = _mapInstanceProperty(values).call(values, function (point) {
      return {
        value: point,
        style: {
          left: (point - min) / total * 100 + '%'
        },
        active: false
      };
    });
    addActive();
  }
  function addActive() {
    var _instance$get3 = instance.get(),
      range = _instance$get3.range;
    var value = showValue.value;
    points.forEach(function (point) {
      point.active = !range ? point.value <= value : point.value >= value[0] && point.value <= value[1];
    });
  }
  return function () {
    return points;
  };
}